let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cmZCT")).then(() => parcelRequire('6G7Pc'));